import { gql } from '@apollo/client';

export * from './escrowInvitation.query.generated';

export const ESCROW_INVITATION = gql`
  query escrowInvitation($id: ID!) {
    escrowInvitation(escrowInvitationId: $id) {
      id
      status
      companyName
      partyType
      policy {
        accept
        reject
        update
      }
      escrow {
        id
        beneficiary {
          id
          companyName
          companyWebsite
        }
        depositor {
          id
          companyName
          companyWebsite
        }
      }
    }
  }
`;
